import { createFileRoute, Outlet } from '@tanstack/react-router';
import ChooseDifferentOptionBtn from '../../../../../components/ChooseDifferentOptionBtn';

export const Route = createFileRoute(
  '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout',
)({
  component: () => (
    <div>
      <Outlet />
      <div className='flex w-full justify-end gap-2.5'>
        <ChooseDifferentOptionBtn />
      </div>
    </div>
  ),
});
